import React, { useEffect, useState } from "react";

// img

// Jds
import { Button, Container, Notifications, Text } from "@jds/core";

// Mui
import { Box, Stack } from "@mui/material";
import AnalyticsCard from "../components/UI/Cards/AnalyticsCard";
import GridContainer from "../components/Layout/GridContainer";
import useApiHttp from "../hooks/use-http";
import { useNavigate, useParams } from "react-router-dom";
import PageLoader from "../components/UI/Loader/PageLoader";
import { bytesToHumanReadable } from "../util/helper";

// Local

export default function AnalyticsPage() {
  // analytics_counts/b50cacd5-b15e-4d76-9409-80a146756681
  const navigate = useNavigate();
  const { id: eventId } = useParams();
  const { sendRequest: getAnalyticsCounts, isLoading: analyticsCountsLoading } =
    useApiHttp();
  const [eventAnalyticsList, setEventAnalyticsList] = useState([]);
  const [mediaAnalyticsList, setMediaAnalyticsList] = useState([]);
  const [analyticsList, setAnalyticsList] = useState([]);
  const [customFieldAnalytics, setCustomFieldAnalytics] = useState([]);
  useEffect(() => {
    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/${eventId}`,
      },
      null,
      (data) => {
        setEventAnalyticsList([
          {
            ic: "IcGroup",
            heading: "All Guests",
            data: data?.data?.allGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "ALL" },
              });
            },
          },
          {
            ic: "IcStamp",
            heading: "Persons Registered",
            data: data?.data?.registeredGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "REGISTERED" },
              });
            },
          },
          {
            ic: "IcRequest",
            // icProps: {
            //   color: "sparkle",
            //   kind: "default",
            //   size: "medium",
            // },
            heading: "Persons Invited",
            data: data?.data?.invitedGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "NULL" },
              });
            },
          },
          {
            ic: "IcSuccess",
            heading: "Persons Approved",
            data: data?.data?.approveGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "APPROVED" },
              });
            },
          },
          {
            ic: "IcCelebration",
            heading: "Persons Attending Event",
            data: data?.data?.totalAccessingGuestCount,
          },
          {
            ic: "IcAccessibility",
            heading: "Persons with Full Access",
            data: data?.data?.fullAccessCount,
          },
          {
            ic: "IcSmileyNeutral",
            heading: "Persons with Face Access",
            data: data?.data?.faceAccessCount,
          },
          // {
          //   ic: "IcDownload",
          //   heading: "Downloads Requested",
          //   data: data?.data?.downloadRequestsCount,
          // },
          {
            ic: "IcDownload",
            heading: "Persons with Download Access",
            data: data?.data?.approvedDownloadCount,
          },
          {
            ic: "IcError",
            heading: "Persons Denied",
            data: data?.data?.denyGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "DENIED" },
              });
            },
          },
          {
            ic: "IcBlocked",
            heading: "Persons Blocked",
            data: data?.data?.blockedGuestCount,
            onClick: () => {
              navigate(`/home/events/guests/${eventId}`, {
                state: { navigate: "blocked" },
              });
            },
          },
          {
            ic: "IcGroup",
            heading: "All Photographers",
            data: data?.data?.allPhotographerCount,
            onClick: () => {
              navigate(`/home/events/photographers/${eventId}`);
            },
          },
          {
            ic: "IcCalendarEvent",
            heading: "Photographers Attending Event",
            data: data?.data?.attendingPhotographerCount,
            onClick: () => {
              navigate(`/home/events/photographers/${eventId}`);
            },
          },
          {
            ic: "IcBlocked",
            heading: "Photographers Blocked",
            data: data?.data?.blockedPhotographerCount,
            onClick: () => {
              navigate(`/home/events/photographers/${eventId}`, {
                state: { navigate: "BLOCKED" },
              });
            },
          },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      }
    );

    getAnalyticsCounts(
      {
        url: `analytics/photos?eventId=${eventId}`,
        base: "MEDIA",
      },
      null,
      (data) => {
        setMediaAnalyticsList([
          {
            ic: "IcPhoto",
            heading: "Event Photos",
            data: data?.data?.eventPhotosCount,
          },
          {
            ic: "IcPhoto",
            heading: "Guest Photos",
            data: data?.data?.guestPhotosCount,
          },
          {
            ic: "IcPhoto",
            heading: "Photos Approved for Guests",
            data: data?.data?.guestApprovedPhotosCount,
          },
          {
            ic: "IcCamera",
            heading: "Photographers Photos",
            data: data?.data?.photographerCount,
          },

          {
            ic: "IcCameraHighEnd",
            heading: "Photos Approved for Photographers",
            data: data?.data?.photographerApprovedCount,
          },

          // {
          //   ic: "IcCompare",
          //   heading: "Persons viewed per photo",
          //   data: data?.data?.registeredGuestCount,
          // },
          // {
          //   ic: "IcDownload",
          //   heading: "Photos Downloaded",
          //   data: data?.data?.downloadRequestsCount,
          // },
          {
            ic: "IcSmileySatisfied",
            heading: "Faces Displayed",
            data: data?.data?.facesCount,
          },
          {
            ic: "IcCloud",
            heading: "Photos Storage (approx)",
            data:
              typeof data?.data?.totalFileSizeBytes === "number" &&
              !isNaN(data?.data?.totalFileSizeBytes) &&
              data?.data?.totalFileSizeBytes > 0
                ? bytesToHumanReadable(data?.data?.totalFileSizeBytes)
                : 0,
          },
          // {
          //   ic: "IcPhotoSize",
          //   heading: "Avarage Photo Size",
          //   data:
          //     typeof data?.data?.averageFileSizeBytes === "number" &&
          //       !isNaN(data?.data?.averageFileSizeBytes) &&
          //       data?.data?.averageFileSizeBytes > 0
          //       ? bytesToHumanReadable(data?.data?.averageFileSizeBytes)
          //       : 0,
          // },
        ]);
      },
      (err, data) => {
        Notifications.toast.error({
          id: "analytics_counts",
          title: data.message,
        });
      }
    );

    getAnalyticsCounts(
      {
        url: `event-attendee/analytics_counts/custom-field/${eventId}`,
      },
      null,
      (data) => {
        setCustomFieldAnalytics(data?.data);
      },
      (err, data) => {
        // console.log('Custom field data', data)
      }
    );
  }, []);

  useEffect(() => {
    if (eventAnalyticsList.length && mediaAnalyticsList.length)
      setAnalyticsList([...eventAnalyticsList, ...mediaAnalyticsList]);
  }, [eventAnalyticsList, mediaAnalyticsList]);
  return (
    <>
      <Container direction="column" gap={8}>
        <Text text="Analytics" appearance="heading-xs" />
        <Text text="Metrics" color="primary_grey_80" appearance="body-m-bold" />
      </Container>
      <Container fullWidth style={{ marginTop: "16px" }}>
        <GridContainer minWidth={"240px"}>
          {analyticsList.map((item, i) => (
            <AnalyticsCard
              key={i}
              icon={item?.ic}
              heading={item?.heading}
              data={item?.data}
              icProps={item?.icProps}
              onClick={item?.onClick}
            />
          ))}
        </GridContainer>
      </Container>
      {customFieldAnalytics.length > 0 && (
        <Box my={3}>
          <Container direction="column" gap={8}>
            <Text
              text="Custom Field Metrics"
              color="primary_grey_80"
              appearance="body-m-bold"
            />
          </Container>
          <Box my={2}>
            <GridContainer
              minWidth={"240px"}
              maxWidth={customFieldAnalytics.length > 3 ? "1fr" : "275px"}
            >
              {customFieldAnalytics.map((data, i) => {
                return (
                  <Box
                    key={i}
                    sx={{
                      border: "1px solid var(--color-primary-grey-40)",
                      borderRadius: "18px",
                      padding: "12px 18px",
                    }}
                  >
                    <Stack sx={{ "& ul": { marginLeft: "4px" } }}>
                      <Text
                        text={data?.questionName}
                        appearance="body-m-bold"
                      />
                      <ul>
                        {data?.answerStats.map((val, i) => (
                          <li>
                            <Text
                              text={`${val?.answer} - ${val?.count}`}
                              appearance="body-s"
                              color="primary-grey-80"
                            />
                          </li>
                        ))}
                      </ul>
                    </Stack>
                  </Box>
                );
              })}
            </GridContainer>
          </Box>
        </Box>
      )}
      {analyticsCountsLoading && <PageLoader open={analyticsCountsLoading} />}
    </>
  );
}
